"use strict";
import React, { useState } from "react";
import { Box } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";
import ApiSidebar from "../../Navigates/ApiSidebar.js";
import VoiceCatalogue from "./VoiceCatalogue.js";
import VoiceSandbox from "./VoiceSandbox.js";
import VoiceBenchmarks from "./VoiceBenchmarks.js";
import ApiSandbox from "./ApiSandbox.js";
import ApiDocumentation from "./ApiDocumentation.js";

// Layout container with sidebar and routed content
const Api = () => {
    const [selectedVoice, setSelectedVoice] = useState(null);

    const handleVoiceSelect = (voiceDetails) => {
        setSelectedVoice(voiceDetails);
    };

    return (
        <Box sx={{ display: "flex" }}>
            <ApiSidebar />
            <Box sx={{ flexGrow: 1, p: 2 }}>
                <Routes>
                    <Route path="voice-catalogue" element={<VoiceCatalogue onVoiceSelect={handleVoiceSelect} />} />
                    <Route path="voice-sandbox" element={<VoiceSandbox selectedVoice={selectedVoice} />} />
                    <Route path="voice-benchmarks" element={<VoiceBenchmarks />} />
                    <Route path="api-sandbox" element={<ApiSandbox />} />
                    <Route path="api-documentation" element={<ApiDocumentation />} />
                    <Route index element={<Navigate to="voice-catalogue" replace />} />
                </Routes>
            </Box>
        </Box>
    );
};

export default Api;
